// extracted by mini-css-extract-plugin
module.exports = {"wrap":"jk","heading":"kk"};